export const trackNavigate = (traits) => {
  if (!(window && window.analytics)) return;

  const combinedTraits = Object.assign({
    navigate_from: window.location.pathname,
    context_user_agent: window.navigator.userAgent,
    context_page_title: window.document.title,
    context_page_url: window.location.href,
    context_page_path: window.location.pathname,
  }, traits);

  window.analytics.track('Main nav navigate', combinedTraits);
};



// WEBPACK FOOTER //
// ../src/templates/MainNav/utils/analytics.js